module.exports = __webpack_public_path__ + "static/media/motivation-1.04c14f71.jpg";